import { bl_fi_mst_branch_customer_link_RowClass } from "../../../dbschema/bl_fi_mst_branch_customer_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class CustomerBranchLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_customer_link: bl_fi_mst_branch_customer_link_RowClass =
    new bl_fi_mst_branch_customer_link_RowClass();
}
